import { call, put, takeLatest } from 'redux-saga/effects';

import getCoordinates from '../../services/geocoding';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getCoordinates, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* geocodingSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
